export default "__VITE_ASSET__ppzUz9wp__"